ApplicationSerializer = require './application'

module.exports = App.PromoSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    clients:
      serialize: 'ids'
    client_tags:
      serialize: 'ids'
    required_all_dishes:
      serialize: 'ids'
    required_any_dishes:
      serialize: 'ids'
    required_any_dish_categories:
      serialize: 'ids'
    restaurants:
      serialize: 'ids'
    bonus_free_dishes:
      serialize: 'ids'
    bonus_dishes:
      serialize: 'ids'
    bonus_client_tag:
      serialize: 'id'
    client_bonus_reset_tags:
      serialize: 'id'
    client_restrict_tags:
      serialize: 'id'
